import { render, staticRenderFns } from "./PendingInviteMenu.vue?vue&type=template&id=e2fbcd84&scoped=true&"
import script from "./PendingInviteMenu.vue?vue&type=script&lang=js&"
export * from "./PendingInviteMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fbcd84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VMenu})
